export enum SortDirectionTypeDto {
  Asc = 'asc',
  Desc = 'desc',
}

export interface SortDirectionQueryParams {
  sortDirection: SortDirectionTypeDto;
}

export interface PaginationQueryParams {
  take?: number;
  skip?: number;
}

export interface BaseListResponseDto<T> {
  data: T;
  total: number;
}

export interface BaseQueryParamsDto extends PaginationQueryParams {
  sortDirection?: string;
  sortBy?: string;
  filterBy?: string;
}

export interface ErrorResponseDto {
  error: string;
  statusCode: number;
  message: string | string[];
}

export enum PhoneNumberTypeDto {
  Home = 'Home',
  Work = 'Work',
  Mobile = 'Mobile',
}

export interface PhoneNumberDto {
  phoneNumber: string;
  type: PhoneNumberTypeDto;
}

export interface IdParamDto {
  id: string;
}
